import { styled } from "styled-components";

import { cssColorsFromBackgroundField } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const Button = styled.button`
    ${cssColorsFromBackgroundField({ color: "P75" })}
    ${redundantCssFromKebab("border-radius", "21px")}
    ${redundantCssFromKebab("border", "0px")}
    ${redundantCssFromKebab("padding", "0.5rem 1.5rem")}
    &:active {
        ${cssColorsFromBackgroundField({ color: "P500" }) || ""}
    }
`;

export const Title = styled.h2`
    ${redundantCssFromKebab("margin", "0 auto")}
    ${redundantCssFromKebab("text-align", "center")}
    ${redundantCssFromKebab("padding", "1rem")}
`;
